<template>
    <div class="is-flex">
        <div class="is-inner-flex lucka">
            <div class="overflow"></div>
            <a href="/lucka" data-title="Lučka"></a>
        </div>
        <div class="is-inner-flex figaro">
            <div class="overflow"></div>
            <a href="/figaro" data-title="Figaro"></a>
        </div>
        <div class="is-inner-flex ola">
            <div class="overflow"></div>
            <a href="/ola" data-title="Ola"></a>
        </div>
        <div class="is-inner-flex tesi">
            <div class="overflow"></div>
            <a href="/tesi" data-title="Tesi"></a>
        </div>
    </div>
</template>

<script>

export default {
    name:'app-flex-header',
}

</script>



// WEBPACK FOOTER //
// src/components/layout/FlexHeaderBar.vue